"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var RoleCell = function RoleCell() {
  return function (_ref) {
    var role = _ref.role;
    return (0, _preact.h)("div", {
      className: "team-overview__table-role"
    }, role);
  };
};

var _default = RoleCell;
exports.default = _default;